'use strict';

var updateDate = require('./updateDate');

function advanceDate(d, unit, num, reset) {
  var set = {};
  set[unit] = num;
  return updateDate(d, set, reset, 1);
}

module.exports = advanceDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/date/internal/advanceDate.js
// module id = 108
// module chunks = 1